module.exports = __webpack_public_path__ + "img/logo.d23cbcb1.png";